export default {
  __max__: 2147483647,
  modal: 8000,
  nav: 5000,
}
